export default "__VITE_ASSET__tHkcbVdJ__"